import React from 'react';
import ReactDOM from "react-dom";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const formatRemainingTime = time => {
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
  
    return `${minutes}:${seconds}`;
};
  
const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return <div className="timer">Too lale...</div>;
    }
  
    return (
      <div className="timer">
        <div className="value">{formatRemainingTime(remainingTime)}</div>
        <div className="text">mins remaining</div>
      </div>
    );
};

const DietPlanTimer = () => {
    return(
        <div className='diet-plan-timer'>
            <div className="timer-wrapper">
                <div className='outer-circle'>
                    <div className='inner-circle'>
                        <CountdownCircleTimer
                            isPlaying
                            duration={300}
                            colors={["#1EA475", "#FF8D52", "#FC4551", "#A30000"]}
                            colorsTime={[300, 150, 75, 0]}
                            onComplete={() => [true, 1000]}
                            >
                            {renderTime}
                        </CountdownCircleTimer>
                    </div>
                </div>
            </div>
            <h2>Stay on the page to approve UPI payment request before the time runs out</h2>
            <p><strong>Note:</strong> Do not hit back button or close this screen untill the transaction is complete</p>
        </div>
    );
}

export default DietPlanTimer;